export type AtlasCoord = {
    i: number,
    j: number,
}

export class JsonArrayWrapper<T> {
    private val: T[]

    constructor(val: T[]) {
        this.val = val
    }

    public get all(): T[] {
        return this.val
    }
}

export class JsonDictionaryWrapper {
    private val: any

    constructor(val: any) {
        this.val = val
    }

    public static create_from_string(s: string) {
        return new JsonDictionaryWrapper(JSON.parse(s))
    }

    public get value(): any {
        return this.val
    }

    private get_typed(key: string, ty: string): any {
        const v = this.val[key]
        if (v == undefined) {
            throw new Error("No key found: " + key + "(" + JSON.stringify(this.val) + ")")
        }

        if (typeof(v) != ty) {
            throw new Error("Bad type found: " + key + "(" + JSON.stringify(this.val) + ")")
        }

        return v
    }
    
    public get_boolean(key: string): boolean {
        return this.get_typed(key, "boolean")
    }
    
    public get_string(key: string): string {
        return this.get_typed(key, "string")
    }

    public exists(key: string): boolean {
        return this.val[key] != undefined
    }

    public is_null(key: string): boolean {
        const v = this.val[key]
        if (v == undefined) {
            throw new Error("No key found: " + key)
        }

        return v == null
    }

    public get_number(key: string): number {
        return this.get_typed(key, "number")
    }
    
    public get_typed_array<T>(key: string, ty: string): T[] {
        let objs: any[] = this.get_typed(key, "object")
        return objs.map(obj => {
            if (typeof(obj) != ty) {
                throw new Error("Bad type found in array: " + key)
            }

            return obj
        })
    }

    public get_number_array(key: string): number[] {
        return this.get_typed_array<number>(key, "number")
    }

    public get_object_array(key: string): JsonArrayWrapper<JsonDictionaryWrapper> {
        let objs: any[] = this.get_typed(key, "object")
        let wrappers: JsonDictionaryWrapper[] = objs.map(obj => new JsonDictionaryWrapper(obj))
        return new JsonArrayWrapper<JsonDictionaryWrapper>(wrappers)
    }

    public get_object(key: string): JsonDictionaryWrapper {
        const v = this.get_typed(key, "object")
        return new JsonDictionaryWrapper(v)
    }
}
